// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7k_sK","item":"styles_item__jX5ft"};